import Factory from "../Factory";
import { FactoryInterface } from "../FactoryInterface";
import { Contract } from "../Entities/Contract/Contract";
import { ContractInterface } from "../Entities/Contract/ContractInterface";
import { AttachmentInterface } from "../Entities/Attachment/AttachmentInterface";
import AttachmentFactory from "./AttachmentFactory";
import ContactForContractFactory from "./ContactForContractFactory";

class ContractFactory extends Factory implements FactoryInterface {
  public create(data: any): ContractInterface {
    const attachments: AttachmentInterface[] = AttachmentFactory.createFromArray(data.attachments);
    const contractParties: AttachmentInterface[] = ContactForContractFactory.createFromArray(data.contactForContracts);
    return new Contract({
      id: data.id,
      avatar: this.getAvatar(attachments, "contract"),
      amazonFolderName: data.amazonFolderName,
      attachments: attachments,
      contractParties: contractParties,
      contractStatusId: data.contractStatusId,
      agencyId: data.agencyId,
      amount: data.amount || 0,
      firstDate: new Date(data.firstDate), // Deprecated, Use contractFirstDate instead
      contractFirstDate: new Date(data.contractFirstDate),
      lastDate: data.lastDate === null ? null : new Date(data.lastDate),
      finalRentalPeriodDate: data.finalRentalPeriodDate === null ? null : new Date(data.finalRentalPeriodDate),
      endDate: data.endDate === null ? null : new Date(data.endDate), // Deprecated, Use contractLastDate instead
      contractLastDate: data.contractLastDate === null ? null : new Date(data.contractLastDate),
      expirationDate: data.expirationDate === null ? null : new Date(data.expirationDate),
      payChargesUntilDate: data.payChargesUntil === null ? null : new Date(data.payChargesUntil),
      checkinDate: data.checkinDate === null ? null : new Date(data.checkinDate),
      checkoutDate: data.checkoutDate === null ? null : new Date(data.checkoutDate),
      createdAt: data.createdAt,
      createdBy: data.createdBy,
      mainTenantContactId: data.mainTenantContactId,
      mainTenantCompanyId: data.mainTenantCompanyId,
      occupants: this.getAdditionalPersons(data.contactForContracts),
      nextContractId: data.nextContractId,
      previousContractId: data.previousContractId,
      unitId: data.unitId,
      updatedAt: new Date(data.updatedAt),
      updatedBy: data.updatedBy,
      removed: data.removed,
      note: data.note,
      paidStatus: data.paidStatus,
      tenantDisplayName: data.tenantDisplayName,
      autoSendInvoiceToTenant: data.autoSendInvoiceToTenant,
      isCommercial: data.isCommercial,
      addressForRentEmail: data.addressForRentEmail
    });
  }

  public reinitialize(data: any): ContractInterface {
    return new Contract({
      ...data,
      avatar: this.getAvatar(data.attachments, "contract"),
    });
  }
}

export default new ContractFactory();
